function isString(s) {
  if(!s) return true // if empty we return true cause it can be a string
  return s.constructor === String
}

export const capitalize = (value) => {
  if(value && isString(value)) {
    const firstChar = value.charAt(0).toUpperCase()
    return `${firstChar}${value.slice(1)}`
  }
  return 'Empty or not a string'
}

export const isEmptyString = (s) => {
  if(isString(s)) {
    if(!s || s.trim() === '') {
      return true
    }
    return false
  }
  throw new Error('Not a string')
}
